import store, { dispatch } from '../redux/store';
import { activeMenu } from '../utils/menu';
import { appId } from '../constants/app';
import { appInitiated, firstPageShowEventCompleted } from '../redux/slice/appSlice';
import { authChannel } from '../broadcast-channels/authBroadcast';
import { CustomEventType, MenuEvent } from '../types/event';
import { getStoredState, REHYDRATE } from 'redux-persist';
import { initGoogleGeocoder, initGooglePlaces } from '../utils/googlePlaces';
import { onAuthInit, setAuthIdentity } from '../redux/slice/authSlice';
import { persistedConfigs } from '../redux/slice';
import { PersistedStateKeys } from '../types/store';
import { setupMockInterceptor } from '../apis';

declare global {
  interface Window {
    pageshowEventCount: number;
  }
}

let initialized: boolean = false;

const initializeApplication = () => {
  if (initialized) {
    return;
  }

  initialized = true;

  window.addEventListener('pageshow', () => {
    if (store.getState().app.firstPageShowEventCompleted || window['pageshowEventCount'] > 1) {
      Object.keys(PersistedStateKeys).forEach((e1) => {
        getStoredState(persistedConfigs[e1 as PersistedStateKeys]).then((e2) => {
          store.dispatch({
            type: REHYDRATE,
            key: e1,
            payload: e2,
          });
        });
      });
      store.dispatch(onAuthInit());
      store.dispatch(appInitiated());
      if (store.getState().app.firstPageShowEventCompleted) {
        store.dispatch(firstPageShowEventCompleted());
      }
    } else {
      store.dispatch(firstPageShowEventCompleted());
    }
  });

  if (window['pageshowEventCount'] === 1 && !store.getState().app.firstPageShowEventCompleted) {
    store.dispatch(firstPageShowEventCompleted());
  }

  document.addEventListener(CustomEventType.MENU, (e: Event) => {
    const value = (e as unknown as MenuEvent).detail;
    if (value) {
      activeMenu.next(value);
    }
  });

  authChannel.onmessage = (message) => {
    if (appId !== message.appId) {
      dispatch(
        setAuthIdentity({
          identity: message.payload.identity,
          loginStatus: message.payload.loginStatus,
          isOwner: message.payload.isOwner,
        }),
      );
    }
  };

  setupMockInterceptor();
  initGooglePlaces();
  initGoogleGeocoder();
};

export default initializeApplication;
